import React from "react";
import { Mail } from "lucide-react";

export default function EmailStrip({ overline = "Get in touch", heading, emails = [] }) {
  return (
    <section className="px-6 lg:px-12 py-14 border-t border-slate-200 bg-white" data-testid="email-strip">
      <div className="max-w-[1400px] flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="max-w-xl">
          <div className="overline">{overline}</div>
          {heading && <h3 className="font-display text-2xl font-extrabold tracking-tight mt-2">{heading}</h3>}
        </div>
        <div className="flex flex-wrap gap-3">
          {emails.map((e) => (
            <a
              key={e.address}
              href={`mailto:${e.address}`}
              className="group inline-flex items-center gap-3 vj-card px-4 py-3 hover:border-[#1E3A8A] transition-colors"
              data-testid={`email-link-${e.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <span className="h-9 w-9 shrink-0 border border-slate-200 flex items-center justify-center text-[#1E3A8A] group-hover:border-[#1E3A8A]">
                <Mail size={16} strokeWidth={1.6} />
              </span>
              <span className="leading-tight">
                <span className="block overline">{e.label}</span>
                <span className="block text-sm font-semibold text-[#0F172A]">{e.address}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
